import React, { lazy, Suspense } from 'react';
import { useLocation } from 'wouter';

import { LoadingText } from '@fragment/ui/src/components/LoadingText';

const WorkspaceCreationFlow = lazy(async () => ({
  default: (await import('./WorkspaceCreationFlow')).WorkspaceCreationFlow,
}));

export const NewWorkspaceModal = () => {
  const [, navigate] = useLocation();
  const searchParams = new URLSearchParams(window.location.search);
  if (searchParams.get('newWorkspace') !== 'true') return null;

  const closeModal = () => {
    searchParams.delete('newWorkspace');
    searchParams.delete('parentWorkspaceId');
    const query = searchParams.toString();
    navigate(`~${window.location.pathname}${query ? `?${query}` : ''}`, {
      replace: true,
    });
  };

  return (
    <Suspense fallback={<LoadingText text="Loading" />}>
      <WorkspaceCreationFlow params={{}} onClose={closeModal} />
    </Suspense>
  );
};
